export const TABLES = {
  WINERIES: 'wineries',
  WINES: 'wines',
  WINERY_ADMINS: 'winery_admins',
  FLIGHTS: 'flights',
  FLIGHT_WINES: 'flight_wines',
};
